import styled from 'styled-components'

import { minmedia } from '../../styles/media-queries'
import { bordergray, lightergray, gold, black, white, inputgray } from '../../styles/colors'

export const NoticeContainer = styled.div`
  transition: all 0.5s;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: ${props => (props.empty ? 'none' : `1px solid ${bordergray}`)};
  cursor: ${props => (props.noLink || props.empty ? 'normal' : 'pointer')};

  ${minmedia.medium`
    padding: 1rem 1.5rem;
    min-height: 75px;
  `}

  ${minmedia.large`
    padding: 1rem 2rem;
  `}
  ${minmedia.xmlarge`
    padding: 1.5rem 2rem;
    min-height: 85px;
  `}

  &:hover {
    background: ${props => (props.noLink || props.empty ? white : lightergray)};
  }

`

export const Content = styled.div`
  transition: all 0.5s;
  position: relative;
  padding: .25rem 0 .25rem 1.25rem;
  width: calc(100% - 2rem);

  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;

  font-size: 16px;
  text-decoration: none;
  color: ${black};
  line-height: 1.2;

  ${minmedia.large`
    font-size: 20px;
  `}
  ${minmedia.xmlarge`
    font-size: 22px;
  `}

  &::before {
    height: 100%;
    width: 3px;
    background: ${gold};
    display: inline-block;
    content: '';
    position: absolute;
    left: 0;
    top: 0;
  }

  span {
    display: block;
    font-size: 14px;
    font-weight: 300;
    color: ${inputgray};
    width: 100%;
    margin-top: .25rem;

    ${minmedia.medium`
      font-size: 18px;
    `}
`

export const IconContainer = styled.div`
  svg {
    width: 1.25rem;
    height: 1.25rem;
    fill: ${gold};

    ${minmedia.large`
      width: 1.5rem;
      height: 1.5rem;
    `}
  }
`



// WEBPACK FOOTER //
// ./src/components/Message/styles.js